/* OGC Pricing wizard - generated from prototype/pricing.html */

  var state = { service: null, who: null, card: null };
  var ALL_STEPS = ['step1','step2','step3a','step3b','resultA','resultB','resultC','resultD','resultEvent'];

  /* Reveal a step below — add active + separator class, then smooth-scroll to it */
  function revealStep(id) {
    var el = document.getElementById(id);
    if (!el) return;
    el.classList.add('active');
    if (id !== 'step1') el.classList.add('has-separator');
    setTimeout(function() {
      var header = document.querySelector('header');
      var offset = (header ? header.offsetHeight : 80) + 40;
      var top = el.getBoundingClientRect().top + window.pageYOffset - offset;
      window.scrollTo({ top: top, behavior: 'smooth' });
    }, 60);
  }

  /* Collapse a step and everything below it */
  function collapseFrom(id) {
    var idx = ALL_STEPS.indexOf(id);
    if (idx < 0) return;
    for (var i = idx; i < ALL_STEPS.length; i++) {
      var el = document.getElementById(ALL_STEPS[i]);
      if (!el) continue;
      if (ALL_STEPS[i] !== 'step1') el.classList.remove('active');
      el.classList.remove('answered', 'has-separator');
      el.querySelectorAll('.choice-card').forEach(function(c) {
        c.classList.remove('selected', 'dimmed');
      });
    }
  }

  function markChoice(stepId, value) {
    var stepEl = document.getElementById(stepId);
    if (!stepEl) return;
    stepEl.classList.add('answered');
    stepEl.querySelectorAll('.choice-card').forEach(function(c) {
      c.classList.remove('selected', 'dimmed');
      if (c.dataset.value === value) c.classList.add('selected');
      else c.classList.add('dimmed');
    });
  }

  function choose(step, value) {
    var resultMap = { nfc: 'resultA', digital: 'resultB', 'team-nfc': 'resultC', 'team-digital': 'resultD' };

    if (step === 1) {
      if (state.service === value) return;
      collapseFrom('step2');
      state.service = value;
      state.who = null;
      state.card = null;
      markChoice('step1', value);

      if (value === 'business-cards') revealStep('step2');
      else revealStep('resultEvent');

    } else if (step === 2) {
      if (state.who === value) return;
      collapseFrom('step3a');
      state.who = value;
      state.card = null;
      markChoice('step2', value);
      revealStep(value === 'individual' ? 'step3a' : 'step3b');

    } else if (step === 3) {
      if (state.card === value) return;

      if (state.card && resultMap[state.card]) {
        var oldResult = document.getElementById(resultMap[state.card]);
        if (oldResult) oldResult.classList.remove('active', 'has-separator');
      }

      state.card = value;
      var step3id = state.who === 'individual' ? 'step3a' : 'step3b';
      markChoice(step3id, value);
      revealStep(resultMap[value]);
    }
  }

  function restart() {
    collapseFrom('step1');
    var firstStep = document.getElementById('step1');
    if (firstStep) firstStep.classList.add('active');
    state = { service: null, who: null, card: null };
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  // Custom dropdowns — menu always opens below the field
  document.querySelectorAll('.fld-select').forEach(function(sel) {
    var trigger = sel.querySelector('.fld-trigger');
    var labelEl = sel.querySelector('.fld-label');

    trigger.addEventListener('click', function(e) {
      e.stopPropagation();
      var wasOpen = sel.classList.contains('open');
      document.querySelectorAll('.fld-select.open').forEach(function(o) {
        o.classList.remove('open');
        o.querySelector('.fld-trigger').setAttribute('aria-expanded', 'false');
      });
      if (!wasOpen) {
        sel.classList.add('open');
        trigger.setAttribute('aria-expanded', 'true');
      }
    });

    sel.querySelectorAll('.fld-menu li').forEach(function(opt) {
      opt.addEventListener('click', function(e) {
        e.stopPropagation();
        sel.dataset.value = opt.dataset.value;
        labelEl.textContent = opt.textContent.trim();

        var hidden = sel.querySelector('input[type="hidden"]');
        if (hidden) {
          hidden.value = opt.dataset.value || opt.textContent.trim();
        }
        trigger.classList.remove('placeholder');
        sel.querySelectorAll('.fld-menu li').forEach(function(o) { o.classList.remove('active'); });
        opt.classList.add('active');
        sel.classList.remove('open');
        trigger.setAttribute('aria-expanded', 'false');
      });
    });
  });

  // Close any open dropdown when clicking elsewhere
  document.addEventListener('click', function() {
    document.querySelectorAll('.fld-select.open').forEach(function(o) {
      o.classList.remove('open');
      o.querySelector('.fld-trigger').setAttribute('aria-expanded', 'false');
    });
  });

  // Recommend the plan tier that fits the entered team / card count.
  // Tiers map to the dashboard user limits: Free ≤30, Growth ≤80, Pro ≤200, Enterprise >200.
  function planIndexForCount(n) {
    if (!n || n < 1) return 2;      // default: Professional
    if (n <= 80) return 1;          // Growth is the minimum recommendation (never Free)
    if (n <= 200) return 2;
    return 3;
  }
  function recommendFromInput(input, gridSelector) {
    var grid = document.querySelector(gridSelector);
    if (!grid) return;
    var idx = planIndexForCount(parseInt(input.value, 10));
    grid.querySelectorAll('.plan-card').forEach(function(card, i) {
      card.classList.toggle('featured', i === idx);
    });
  }

  // Monthly / yearly billing toggle — swaps every plan price + note
  function setBilling(period) {
    document.querySelectorAll('.plan-price .amount[data-' + period + ']').forEach(function(el) {
      el.textContent = el.getAttribute('data-' + period);
    });
    document.querySelectorAll('.plan-price-note[data-' + period + ']').forEach(function(el) {
      el.textContent = el.getAttribute('data-' + period);
    });
    document.querySelectorAll('.bill-opt').forEach(function(b) {
      b.classList.toggle('active', b.dataset.period === period);
    });
  }
  // Default to yearly pricing on load
  setBilling('yr');

  // ── Full feature comparison table ──
  var COMPARE_DATA = [
    { cat: "Administration", rows: [
      ["User Management", "Up to 30 users", "Up to 80 users", "Up to 200 users", "Unlimited"],
      ["Admin Seats", "1 admin", "3 admins", "10 admins", "Unlimited"],
      ["Restrict Individual Profile Editing", false, true, true, true],
      ["Individual and Admin Activity Log", false, true, true, true],
      ["Integrations", false, true, true, true],
      ["Team Verification Badge", false, false, true, true],
      ["Sub-Dashboard Management", false, false, false, true],
      ["Granular Access Controls", false, false, false, true]
    ]},
    { cat: "Business Card Customisation", rows: [
      ["Bulk Editing and Customisation", true, true, true, true],
      ["Custom Logo Placement", false, true, true, true],
      ["Custom Profile Templates", "1 Template", "3 Templates", "10 Templates", "Unlimited"],
      ["Hide OGC Footer", false, true, true, true],
      ["Custom Footer Logo", false, false, false, true],
      ["Custom Mobile Wallet Logo", false, false, false, true],
      ["White-label Domains & Fonts", false, false, false, true]
    ]},
    { cat: "CRM & Deal Management", rows: [
      ["Organisation Contact Book & Company List", false, "Up to first 300 contacts", "Unlimited", "Unlimited"],
      ["Centralised Lead Management", false, "Up to first 100 leads", "Unlimited", "Unlimited"],
      ["Centralised Deal Management", false, "Up to first 100 deals", "Unlimited", "Unlimited"],
      ["Custom Deal Properties", false, "Limited", "Unlimited", "Unlimited"],
      ["Custom Deal Pipeline", false, "1 Team Pipeline", "10 Team Pipelines", "Unlimited"],
      ["Advanced Filters", false, false, true, true],
      ["Advanced CRM Controls", false, false, true, true],
    ]},
    { cat: "Sales Tools", rows: [
      ["Invoices, Templates, Verifications", true, true, true, true],
      ["Request Document Signature", false, true, true, true],
      ["Sales Templates", "1 Template", "20 Templates", "20 Templates", "Unlimited"]
    ]},
    { cat: "Analytics", rows: [
      ["Profile Engagement", true, true, true, true],
      ["CRM Analytics", false, true, true, true],
      ["Analytics History", "Up to 90 days", "Up to 1 year", "Up to 3 years", "Lifetime"],
      ["Export Analytics as CSV", false, true, true, true]
    ]},
    { cat: "Support & Security", rows: [
      ["2-step Verification", true, true, true, true],
      ["Priority Customer Support", false, true, true, true],
      ["Dedicated Account Manager", false, false, true, true],
    ]}
  ];

  function cmpCell(v) {
    if (v === true)  return '<td><span class="cmp-ic cmp-yes"><svg viewBox="0 0 20 20" fill="none"><circle cx="10" cy="10" r="10" fill="#DCF1E6"/><path d="M6 10.5l2.5 2.5L14 7.5" stroke="#2E9E68" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"/></svg></span></td>';
    if (v === false) return '<td><span class="cmp-ic cmp-no"><svg viewBox="0 0 20 20" fill="none"><circle cx="10" cy="10" r="10" fill="#FBE6E6"/><path d="M7 7l6 6M13 7l-6 6" stroke="#E0726F" stroke-width="1.9" stroke-linecap="round"/></svg></span></td>';
    return '<td><span class="cmp-txt">' + v + '</span></td>';
  }

  // Individual: OGC Basic vs OGC Pro
  var COMPARE_PRO = [
    { cat: "Essentials", rows: [
      ["Widget Catalogue", true, true],
      ["Multi-Profile Display", false, true],
      ["Hide OGC Footer", false, true],
      ["Integrations", "1 Integration", "Unlimited"]
    ]},
    { cat: "Business Cards", rows: [
      ["Custom Profile Styling", true, true],
      ["Profile Sharing Tools", true, true],
      ["Offline Mode", true, true],
      ["Custom Logo", false, true],
      ["Custom CTA Buttons", false, true],
      ["Custom Splash Screen", false, true]
    ]},
    { cat: "CRM", rows: [
      ["Deal Manager", true, true],
      ["Deal Pipelines", "1 Pipeline", "3 Pipelines"],
      ["Custom Deal Pipelines", false, true],
      ["Custom Deal Properties", false, true],
      ["Export Contacts as CSV", false, true]
    ]},
    { cat: "Sales Tools", rows: [
      ["OCR Business Card Scanner", "Limited", true],
      ["Email Verifications", "Limited", true],
      ["Smart Contact Enrichments", "Limited", true],
      ["Request Document Signature", false, true],
      ["Schedule Document Sending", false, true],
      ["Sales Templates", "1 Template", "20 Templates"]
    ]},
    { cat: "Analytics", rows: [
      ["Profile Analytics", true, true],
      ["Analytics History", "30 Days", "365 Days"],
      ["CRM Analytics", false, true]
    ]}
  ];

  var COLS_DASH = [["Free","free"],["Growth","growth"],["Professional","pro"],["Enterprise","ent"]];
  var COLS_PRO  = [["Free","free"],["Pro","blue"]];

  function buildCompareTable(groups, cols) {
    var h = '<table class="cmp"><thead><tr><th></th>';
    cols.forEach(function(c) { h += '<th><span class="cmp-pill ' + c[1] + '">' + c[0] + '</span></th>'; });
    h += '</tr></thead><tbody>';
    groups.forEach(function(group) {
      h += '<tr class="cmp-cat"><td colspan="' + (cols.length + 1) + '">' + group.cat + '</td></tr>';
      group.rows.forEach(function(r) {
        h += '<tr><td class="cmp-feat">' + r[0] + '</td>';
        for (var i = 1; i < r.length; i++) h += cmpCell(r[i]);
        h += '</tr>';
      });
    });
    return h + '</tbody></table>';
  }

  document.querySelectorAll('.compare-panel').forEach(function(p) {
    if (p.dataset.compare === 'pro') p.innerHTML = buildCompareTable(COMPARE_PRO, COLS_PRO);
    else p.innerHTML = buildCompareTable(COMPARE_DATA, COLS_DASH);
  });

  function toggleCompare(btn) {
    var panel = btn.parentNode.querySelector('.compare-panel');
    var open = panel.hidden;
    panel.hidden = !open;
    btn.classList.toggle('open', open);
    btn.querySelector('span').textContent = open ? 'Hide full feature comparison' : 'Compare all features';
  }

  function showOgcToast(message) {
    var oldToast = document.querySelector('.ogc-toast');
    if (oldToast) oldToast.remove();

    var toast = document.createElement('div');
    toast.className = 'ogc-toast';
    toast.textContent = message;

    document.body.appendChild(toast);

    requestAnimationFrame(function () {
      toast.classList.add('show');
    });

    setTimeout(function () {
      toast.classList.remove('show');
      setTimeout(function () {
        toast.remove();
      }, 250);
    }, 3500);
  }

  document.addEventListener('DOMContentLoaded', function () {
    if (
      window.location.search.indexOf('contact_posted=true') > -1
    ) {
      showOgcToast('Received! We will get back to you shortly.');

      if (history.replaceState) {
        history.replaceState(null, '', window.location.pathname);
      }
    }
  });

  // Shopify quote form validation
  document.addEventListener('submit', function(e) {
    var form = e.target;

    if (!form.matches('.quote-form, form[action*="/contact"]')) return;

    if (!form.checkValidity()) {
      e.preventDefault();
      form.reportValidity();
      return;
    }

    var hiddenRequired = form.querySelectorAll('.fld-select input[type="hidden"][required]');

    for (var i = 0; i < hiddenRequired.length; i++) {
      var input = hiddenRequired[i];
      var select = input.closest('.fld-select');
      var trigger = select.querySelector('.fld-trigger');

      if (!input.value || !input.value.trim()) {
        e.preventDefault();
        trigger.classList.add('error');
        trigger.focus();
        return;
      }

      trigger.classList.remove('error');
    }

    var submitBtn = form.querySelector('button[type="submit"]');
    if (submitBtn) {
      submitBtn.disabled = true;
      submitBtn.textContent = 'Sending...';
    }
  }, true);

if (window.lucide) { window.lucide.createIcons(); }
